import React from "react";
import { useFormikContext } from "formik";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    margin-bottom: 0px !important;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
`;

const SalesAndPurchases = ({
  paymentTermsList,
  websiteList,
  industryList,
  fiscalInformationList,
  disabled,
}) => {
  const { values } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];
  return (
    <div>
      <FormContainer className="row g-3 px-2">
        {/* <div className="row p-0 justify-content-between align-items-center">
          <div className="col">
            <h5 className="me-2 mb-2  sales_heading">{t["Sales"]}</h5>
          </div>
        </div>

        <div className="col-md-6 ">
          <StyledLabel
            htmlFor="OpportunityName"
            className="form-label"
            defaultValue=""
          >
            {t["Phone"]}
          </StyledLabel>
          <FormikInput name="name" />
        </div>
        <div className="col-md-6">
          <StyledLabel
            htmlFor="inputPassword4"
            className="form-label"
            defaultValue=""
          >
            {t["Mobile"]}
          </StyledLabel>
          <FormikInput type="text" name="address" />
        </div>
        <div className="col-md-6 ">
          <StyledLabel
            htmlFor="OpportunityName"
            className="form-label"
            defaultValue=""
          >
            {t["Website Link"]}
          </StyledLabel>
          <FormikInput
            type="text"
            name="address"
            // options={LEAD_STATUS}
          />
        </div>
        <div className="col-md-6">
          <StyledLabel
            htmlFor="OpportunityName"
            className="form-label"
            defaultValue=""
          >
            {t["Language"]}
          </StyledLabel>
          <FormikSelect
            name="language"
            // options={LEAD_PRIORITY}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                height: "58px",
                borderRadius: "15px",
                border: "1px solid #CBCBCB",
                background: "#F5F5F5",
              }),
            }}
          />
        </div> */}
        <h5 className="me-2 mb-2  sales_heading">{t["Purchase"]}</h5>

        <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            name="property_supplier_payment_term_id"
            label={t["Payment Terms"]}
            options={paymentTermsList}
          />
        </div>

        <div className="col-12">
          <h5 className="me-2 mb-2  sales_heading">{t["Point of Sale"]}</h5>
        </div>

        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            label={t["Barcode"]}
            name="barcode"
          />
        </div>
        <div className="col-12">
          <h5 className="me-2 mb-2  sales_heading">
            {t["Fiscal Information"]}
          </h5>
        </div>

        <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            options={fiscalInformationList}
            name="property_account_position_id"
            label={t["Fiscal Information"]}
          />
        </div>
        <div className="col-12">
          <h5 className="me-2 mb-2  sales_heading">{t["Misc"]}</h5>
        </div>
        <div className="col-md-4">
          <FormikInput disabled={disabled} label={t["Reference"]} name="ref" />
        </div>
        <div className="col-md-4">
          <FormikSelect
            disabled={disabled}
            name="website_id"
            options={websiteList}
            label={t["Website"]}
          />
        </div>
        {!values?.parent_id && (
          <div className="col-md-4">
            <FormikSelect
              disabled={disabled}
              name="industry_id"
              options={industryList}
              label={t["Industry"]}
            />
          </div>
        )}
      </FormContainer>
    </div>
  );
};

export default SalesAndPurchases;
